import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import TopBar from "../../components/TopBar";
import { collection, getDocs, query, where } from "firebase/firestore";
import { collectionNames, wordstToOmitt } from "../../utils/Constants";
import { db } from "../../utils/firebase";
import { FaDownload } from "react-icons/fa";
import { htmlStringToPdf } from "../../helpers/htmlToPdf";
import Button from "../../components/Button";
import CompareModal from "./components/CompareModal";
import AverageGraph from "./components/AverageGraph";
import GraphForStrings from "./components/GraphForStrings";
import { inputTypes, tableData } from "../../utils/tableData";
import { getConfigDataByName } from "./components/getConfigDataByName";
import Slider from "react-input-slider";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import nlp from "compromise";
import { Bar } from "react-chartjs-2";
import { generateRandomHexCode } from "../../helpers/generateRandomHexCode";
import MultiSelectBtns from "../../components/MultiSelectBtns";
import countWords from "../../helpers/countWords";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import WordCloudComp from "../../components/WordCloudComp";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const centerTextPlugin = {
  id: "centerText",
  afterDraw: (chart) => {
    const ctx = chart.ctx;
    ctx.font = "bold 12px Arial";
    ctx.fillStyle = "white";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        const xPos = bar.x;
        const yPos = bar.y + bar.height / 2; // Adjust for center positioning
        ctx.fillText(value, xPos, yPos);
      });
    });
  },
};
const SessionDetails = () => {
  const pdfRef = useRef();

  const [surveys, setSurveys] = useState([]);
  const [selectedSurveys, setSelectedSurveys] = useState([]);
  const [showCompareModal, setShowCompareModal] = useState(false);
  const [details, setDetails] = useState();
  const getSurveys = async () => {
    const q = query(
      collection(db, collectionNames.SURVEYS),
      where("sessionId", "==", session?.id)
    );

    const querySnapshot = await getDocs(q);
    let tmpSurveys = [];

    querySnapshot.forEach((doc) => {
      if (doc.data()) {
        tmpSurveys.push({ id: doc.id, ...doc.data() });
      }
    });
    setSurveys(tmpSurveys);
    generateDetails(tmpSurveys);
  };

  const generateDetails = (surveys) => {
    let tmpDtls = {};
    let tmpTextString = {};
    surveys.forEach((sv) => {
      console.log(sv, "ssssss");
      Object.keys(sv).forEach((key) => {
        let dataConfig = getConfigDataByName(key);
        if (key == "mainProplem") {
          console.log(sv[key], "svkey");
          if (tmpTextString[key]) {
            tmpTextString[key] = tmpTextString[key] + " " + sv[key];
          } else {
            tmpTextString[key] = sv[key];
          }
          const object = stringToData(tmpTextString[key]);
          tmpDtls[key] = getTopEightValues(object);
        } else if (dataConfig?.input.type == inputTypes.slider) {
          if (tmpDtls[key]?.total) {
            tmpDtls[key].total = tmpDtls[key].total + Number(sv[key]);
          } else {
            tmpDtls[key] = { 0: 0, 50: 0, 100: 0 };

            tmpDtls[key].total = Number(sv[key]);
          }
          if (tmpDtls[key]?.[sv[key]]) {
            tmpDtls[key][sv[key]] = tmpDtls[key][sv[key]] + 1;
          } else if (tmpDtls[key]) {
            tmpDtls[key][sv[key]] = 1;
          } else {
            tmpDtls[key][sv[key]] = 1;
          }
        } else if (dataConfig?.input.type == inputTypes.dropDown) {
          if (tmpDtls[key]?.[sv[key]]) {
            tmpDtls[key][sv[key]] = tmpDtls[key][sv[key]] + 1;
          } else if (tmpDtls[key]) {
            tmpDtls[key][sv[key]] = 1;
          } else {
            tmpDtls[key] = {};
            dataConfig?.input?.options?.forEach((str) => {
              tmpDtls[key][str] = 0;
            });
            tmpDtls[key][sv[key]] = 1;
          }
        } else if (dataConfig?.input.type == inputTypes.checkBoxGroup) {
          sv[key]?.forEach((it) => {
            if (tmpDtls[key]?.[it]) {
              tmpDtls[key][it] = tmpDtls[key][it] + 1;
            } else if (tmpDtls[key]) {
              tmpDtls[key][it] = 1;
            } else {
              tmpDtls[key] = {};
              dataConfig?.input?.options?.forEach((str) => {
                tmpDtls[key][str] = 0;
              });
              // tmpDtls[key] = {};
              tmpDtls[key][it] = 1;
            }
          });
        } else if (dataConfig?.input.type == inputTypes.textArea) {
          if (tmpTextString[key]) {
            tmpTextString[key] = tmpTextString[key] + " " + sv[key];
          } else {
            tmpTextString[key] = sv[key];
          }
          const object = stringToData(tmpTextString[key]);
          tmpDtls[key] = getTopEightValues(object);
        } else if (dataConfig?.input.type == inputTypes.textAreaGroup) {
          if (tmpTextString[key]) {
            tmpTextString[key] = tmpTextString[key] + " " + sv[key];
          } else {
            tmpTextString[key] = sv[key];
          }
          const object = stringToData(tmpTextString[key]);
          tmpDtls[key] = getTopEightValues(object);
        }
      });
    });
    console.log(tmpDtls, "tmpDtls");
    console.log(stringToData(tmpTextString));
    setDetails(tmpDtls ?? {});
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "chart",
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 16,
          },
        },
      },
    },
  };
  const filterSliderValues = (object, input) => {
    let obj = { ...object };
    delete obj.total;
    const tmpLabels = Object.keys(obj ?? {});
    let labels = [];
    tmpLabels.forEach((a) => {
      if (a == 0) {
        labels.push(input.low ?? "Low");
      } else if (a == 50) {
        labels.push(input.medium ?? "Moderate");
      } else if (a == 100) {
        labels.push(input.high ?? "High");
      } else {
        labels.push(a);
      }
    });
    return {
      labels,
      data: Object.values(obj ?? {}),
    };
  };
  const getTopEightValues = (object) => {
    const entries = Object.entries(object);
    entries.sort((a, b) => b[1] - a[1]);
    const top8Entries = entries.slice(0, 8);
    return Object.fromEntries(top8Entries);
  };
  const stringToData = (string) => {
    const cleanedString = removeWordsFromString(string);
    let doc = nlp(cleanedString);
    doc.pronouns().delete();
    doc.adjectives().delete();
    doc.prepositions().delete();
    doc.conjunctions().delete();

    return countWords(doc.text() ?? "");
  };
  function removeWordsFromString(str) {
    if (!str || typeof str !== "string") return ""; // Ensure str is a valid string

    const regex = new RegExp(`\\b(${wordstToOmitt.join("|")})\\b`, "gi");
    return str.replace(regex, "").replace(/\s+/g, " ").trim();
  }
  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      // Use the full width and height of the content
      const pdfWidth = canvas.width * 0.2645; // Convert px to mm
      const pdfHeight = canvas.height * 0.2645;

      const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]); // Custom size
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("session-details.pdf");
    });
  };

  const ItemComp = ({ input, bgColor }) => {
    return (
      <div className="mb-2 p-1 sm:p-2 flex items-center">
        {input.name == "indivPerspective" ||
        input.name == "clinicalDecisionMaking" ? (
          <div className="mt-5">
            <MultiSelectBtns
              disabled={true}
              label={""}
              options={input.options.map((a) => ({
                label: a,
                value: a,
              }))}
              multiselect={input.multiselect}
            />
          </div>
        ) : input.name == "additionalComments " ||
          input.name == "clinicaltimeframe" ||
          input.name == "mainProplem" ||
          input.name == "diagnosis_input" ? (
          <div>
            <WordCloudComp data={details[input.name]} />
          </div>
        ) : input.type == inputTypes.slider ? (
          <div className="flex items-center gap-10 ">
            <div className="w-[250px] pl-1 md:pl-0 flex items-center justify-center space-x-3">
              <p className="mr-2  text-xl text-gray-600 w-auto  md:w-28 text-center lg:text-right">
                {input.low ?? "Low"}
              </p>
              <div className="lg:pl-0 w-32 lg:w-[200px]">
                <Slider
                  axis="x"
                  x={(details[input.name]?.total ?? 0) / surveys.length}
                  // onChange={({ x }) => setFieldValue(input.name, getSliderStep(x))}
                  styles={{
                    track: {
                      width: "100%",
                    },
                  }}
                />
              </div>
              <p className="text-xl text-gray-600 md:w-16 text-center">
                {input.high ?? "High"}
              </p>
            </div>
            {/* <div className="w-[300px] ">
              <Slider
                axis="x"
                x={(details[input.name]?.total ?? 0) / surveys.length}
              />
            </div> */}
            <div className="h-[250px]">
              <Bar
                options={options}
                data={{
                  labels: filterSliderValues(details[input.name] ?? {}, input)
                    .labels,

                  datasets: [
                    {
                      label: "Survey",
                      data: filterSliderValues(details[input.name] ?? {}, input)
                        .data,
                      backgroundColor: bgColor ?? "blue",
                    },
                  ],
                }}
                plugins={[centerTextPlugin]}
              />
            </div>
          </div>
        ) : input.type == inputTypes.textAreaGroup ? (
          <div className="flex flex-row gap-x-10">
            {input.textAreas.map((ta) => (
              <div className="">
                <p className="text-lg">{ta.label}</p>
                <div className="mt-3 h-[250px]">
                  <WordCloudComp data={details[ta.name]} />
                  {/* <Bar
                    options={options}
                    data={{
                      labels: Object.keys(details[ta.name] ?? {}),

                      datasets: [
                        {
                          label: "Survey",
                          data: Object.values(details[ta.name] ?? {}),
                          backgroundColor: bgColor ?? "blue",
                        },
                      ],
                    }}
                    plugins={[centerTextPlugin]}
                  /> */}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex items-center gap-10">
            <div className="w-[250px] " />
            <div className="h-[250px]">
              <Bar
                options={options}
                data={{
                  labels: Object.keys(details[input.name] ?? {}),

                  datasets: [
                    {
                      label: "Survey",
                      data: Object.values(details[input.name] ?? {}),
                      backgroundColor: bgColor ?? "blue",
                    },
                  ],
                }}
                plugins={[centerTextPlugin]}
              />
            </div>
          </div>
        )}
      </div>
    );
  };
  const formattedDate = (date) =>
    date.toLocaleDateString("en-GB").split("/").join("-");

  useEffect(() => {
    getSurveys();
  }, []);
  const { session } = useLocation().state ?? {};
  if (!details) return null;
  return (
    <div>
      <TopBar title={session.name} />
      <div className="m-3 flex items-center justify-end ">
        <button onClick={downloadPDF} className="bg-blue-500 text-white p-2">
          Download PDF
        </button>
      </div>
      <div ref={pdfRef} className="p-5">
        <h1 className="font-bold text-2xl mb-1">{session.name}</h1>
        <p className="text-lg">Total responses: {surveys?.length}</p>
        <p className="mb-3 text-lg">{formattedDate(new Date())}</p>
        {selectedSurveys.length > 0 && (
          <div className="mb-2 flex justify-end">
            <Button label="Compare" onClick={() => setShowCompareModal(true)} />
          </div>
        )}
        <div className="border">
          <div className="mb-3  sm:mb-0 flex flex-col sm:flex-row ">
            <div
              className="pl-2 w-full md:w-[150px] sm:w-[247px] bg-gray-300 flex items-center sm:justify-center  shrink-0"
              style={{ backgroundColor: "gray" }}
            >
              <p className="sm:text-center text-center text-white text-3xl">
                Main Problem
              </p>
            </div>
            <div className="h-full w-full">
              <div className="h-full flex flex-col sm:flex-row">
                <div className=" sm:w-[200px]  p-2 flex  items-center sm:justify-center sm:border-r ">
                  <p className="text-center sm:w-1/2 "></p>
                </div>

                <ItemComp
                  input={{
                    type: inputTypes.textArea,
                    name: "mainProplem",
                    label: "",
                  }}
                  bgColor={"gray"}
                />
              </div>
            </div>
            {/* <div className="border h-full  w-full">
                <ItemComp input={{
                  type:inputTypes.textArea,
                  name:'mainProplem',
                  label:''
                }} bgColor={'gray'} />
                
              </div> */}
          </div>

          {tableData.map((item, idx) => (
            <div key={idx} className="mb-3 sm:mb-0 flex flex-col sm:flex-row ">
              <div
                className="pl-2 w-full md:w-[150px] sm:w-1/5 shrink-0 bg-gray-300 flex items-center sm:justify-center"
                style={{ backgroundColor: item.bg }}
              >
                {item.titleImg ? (
                  <img src={item.titleImg} className="" />
                ) : (
                  <p className="sm:text-center text-center text-white text-3xl">
                    {item.title}
                  </p>
                )}
                {/* <p className="sm:text-center">{item.title}</p> */}
              </div>

              <div className="border h-full  w-full ">
                {/* To show if sub items are there */}
                {item.subs ? (
                  <div className="h-full ">
                    {item.subs.map((sub, idx) => (
                      <div
                        className="h-full flex flex-col sm:flex-row"
                        key={idx}
                      >
                        <div className=" sm:w-[200px]  p-2 flex  items-center sm:justify-center sm:border-r ">
                          <p className="text-center sm:w-1/2 text-lg">
                            {sub.title}
                          </p>
                        </div>

                        <ItemComp input={sub.input} bgColor={item.bg} />
                      </div>
                    ))}
                  </div>
                ) : (
                   <ItemComp input={item.input} bgColor={item.bg} />
                )}
              </div>
            </div>
          ))}
        </div>
        {/* {surveys.length && <AverageGraph surveys={surveys} />}
        {surveys.length && <GraphForStrings surveys={surveys} />} */}
        {/* <div class="overflow-x-auto">
          <table class="table-auto w-full">
            <thead className="bg-slate-200">
              <tr>
                <th class="px-4 py-2 w-20">#</th>
                <th class="px-4 py-2">Survey </th>
                <th class="px-4 py-2 w-10"></th>
              </tr>
            </thead>
            <tbody>
              {surveys.map((item, idx) => (
                <tr>
                  <td class="border px-4 py-2">
                    <input
                      type="checkbox"
                      onChange={() => checkBoxClickHandler(item)}
                    />
                  </td>
                  <td class="border px-4 py-2">Survey {idx + 1}</td>
                  <td class="border px-4 py-2">
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}
      </div>

      {showCompareModal && (
        <CompareModal
          selectedSurveys={selectedSurveys.map((a) => {
            let item = a;
            delete item.id;
            delete item.timestamp;
            delete item.userId;
            return item;
          })}
          onClose={() => setShowCompareModal(false)}
        />
      )}
    </div>
  );
};

export default SessionDetails;
